const config = {
  url: '/',
  sentryDSN: 'https://09e43fbe852741e3946233c3af922a2a@sentry.io/1770288',
};

export default config;
